import { CallbackMessage } from '../CallbackMessage'

const success = (email: string) =>
  `Successfully authenticated with email address: ${email}. You can close this window now.`

/** `/auth/gmail_callback`: the Gmail popup target; posts on `gmailAuth` (portal pages/auth/gmail_callback.tsx). */
export function GmailCallbackPage() {
  return (
    <CallbackMessage
      channel="gmailAuth"
      success={success}
      missing="An error occurred in the authentication process. No email address found in the callback URL."
    />
  )
}
